import Article from "./Article";

const PageContent = ({ items, articles }) => {
  return (
    <>
      {items && <Article items={items} />}
      {articles ? (
        Array.isArray(articles) ? (
          articles?.map((article, idx) =>
            article?.type != null ? (
              <span key={article?.id || `article_${idx}`}>{article}</span>
            ) : (
              <Article key={article?.id || `article_${idx}`} {...article} />
            )
          )
        ) : (
          <Article key={articles?.id} {...articles} />
        )
      ) : null}
    </>
  );
};

export default PageContent;
